import { create } from '../../utils/create';
export class Filters {
    constructor(parent, onFilterClick, onNameClick, onReSetClick, header) {
        this.update = (props) => {
            this.render(props);
        };
        this.render = (props) => {
            var _a;
            (_a = this.component) === null || _a === void 0 ? void 0 : _a.remove();
            const btnReset = create({
                tagName: 'button',
                classNames: 'btn',
                children: 'Reset Filters',
                dataAttr: [['id', 'btnReset']]
            });
            btnReset.addEventListener('click', () => {
                this.onReSetClick();
                localStorage.setItem('searchInput', '');
                this.header.renderSearchWrapper();
                this.header.renderCartWrapper();
            });
            const btnCopy = create({
                tagName: 'button',
                classNames: 'btn',
                children: 'Copy',
                dataAttr: [['id', 'btnCopy']]
            });
            btnCopy.addEventListener('click', () => {
                btnCopy.style.color = 'red';
                btnCopy.style.backgroundColor = 'rgb(83, 83, 83)';
                setTimeout(() => {
                    btnCopy.style.color = 'rgb(83, 83, 83)';
                    btnCopy.style.backgroundColor = '#ffbd59';
                    navigator.clipboard.writeText(window.location.href);
                }, 1000);
            });
            const nameItem = props === null || props === void 0 ? void 0 : props.names.map((item) => {
                var _a;
                const dataAttr = [
                    ['type', 'checkbox'],
                    ['id', item.name]
                ];
                if ((_a = props === null || props === void 0 ? void 0 : props.activeNameFiltrs) === null || _a === void 0 ? void 0 : _a.includes(item.name)) {
                    dataAttr.push(['checked', '']);
                }
                const checkBox = create({
                    tagName: 'input',
                    classNames: 'custom__checkbox',
                    dataAttr
                });
                const element = create({
                    tagName: 'div',
                    classNames: 'filters__item-list-wrapper',
                    children: [
                        checkBox,
                        create({
                            tagName: 'label',
                            classNames: 'label',
                            dataAttr: [['for', item.name]],
                            children: item.name
                        }),
                        create({
                            tagName: 'span',
                            classNames: 'filters__item-name',
                            children: `(${item.count}/${item.baseCount})`
                        })
                    ]
                });
                checkBox.addEventListener('click', () => this.onNameClick(item.name, checkBox.checked));
                return element;
            });
            const categoryItem = props === null || props === void 0 ? void 0 : props.categories.map((item) => {
                var _a;
                const dataAttr = [
                    ['type', 'checkbox'],
                    ['id', item.name]
                ];
                if ((_a = props === null || props === void 0 ? void 0 : props.activeCategoriesFilters) === null || _a === void 0 ? void 0 : _a.includes(item.name)) {
                    dataAttr.push(['checked', '']);
                }
                const checkBox = create({
                    tagName: 'input',
                    classNames: 'custom__checkbox',
                    dataAttr
                });
                const element = create({
                    tagName: 'div',
                    classNames: 'filters__item-list-wrapper',
                    children: [
                        checkBox,
                        create({
                            tagName: 'label',
                            classNames: 'label',
                            dataAttr: [['for', item.name]],
                            children: item.name
                        }),
                        create({
                            tagName: 'span',
                            classNames: 'filters__item-name',
                            children: `(${item.count}/${item.baseCount})`
                        })
                    ]
                });
                checkBox.addEventListener('click', () => this.onFilterClick(item.name, checkBox.checked));
                return element;
            });
            const titleSubline = create({
                tagName: 'div',
                classNames: 'filters__item-title-subline'
            });
            const rangeInputPrice = create({
                tagName: 'div',
                children: `
        <input
         ${(props === null || props === void 0 ? void 0 : props.minVal) ? `data-value-min="${props.minVal}"` : ''}
         ${(props === null || props === void 0 ? void 0 : props.maxVal) ? `data-value-max="${props.maxVal}"` : ''}
          data-min="14"
          data-max="4180"
          data-role="doubleslider"
          class="input-range ultra-thin cycle-marker"
          id="priceDoubleSlider"
        />
      `
            });
            const rangeInputStock = create({
                tagName: 'div',
                children: `
      <input
       ${(props === null || props === void 0 ? void 0 : props.maxStocks) ? `data-value-min="${props.minStocks}"` : ''}
       ${(props === null || props === void 0 ? void 0 : props.maxStocks) ? `data-value-max="${props.maxStocks}"` : ''}
        data-min="7"
        data-max="200"
        data-role="doubleslider"
        class="input-range ultra-thin cycle-marker"
        id="stockDoubleSlider"
      />
    `
            });
            this.component = create({
                tagName: 'div',
                classNames: 'filters',
                children: [
                    create({
                        tagName: 'div',
                        classNames: 'reset',
                        children: [btnReset, btnCopy]
                    }),
                    create({
                        tagName: 'div',
                        classNames: 'filters__items-wrapper',
                        children: [
                            create({
                                tagName: 'div',
                                classNames: 'filters__item',
                                children: [
                                    create({
                                        tagName: 'h3',
                                        classNames: 'filters__item-title',
                                        children: 'Category'
                                    }),
                                    titleSubline,
                                    create({
                                        tagName: 'div',
                                        classNames: 'filters__item-list',
                                        children: categoryItem
                                    })
                                ]
                            }),
                            create({
                                tagName: 'div',
                                classNames: 'filters__item',
                                children: [
                                    create({
                                        tagName: 'h3',
                                        classNames: 'filters__item-title',
                                        children: 'Name'
                                    }),
                                    titleSubline,
                                    create({
                                        tagName: 'div',
                                        classNames: 'filters__item__list',
                                        children: nameItem
                                    })
                                ]
                            }),
                            create({
                                tagName: 'div',
                                classNames: 'filters__item',
                                children: [
                                    create({
                                        tagName: 'h3',
                                        classNames: 'filters__item-title',
                                        children: 'Price'
                                    }),
                                    titleSubline,
                                    create({
                                        tagName: 'div',
                                        classNames: 'range',
                                        children: [
                                            create({
                                                tagName: 'div',
                                                classNames: 'range__text',
                                                children: [
                                                    create({
                                                        tagName: 'span',
                                                        classNames: 'range__span',
                                                        children: [
                                                            'From ',
                                                            create({
                                                                tagName: 'span',
                                                                children: `${(props === null || props === void 0 ? void 0 : props.minVal) ? props.minVal : '14'} $`,
                                                                dataAttr: [['id', 'min__range']]
                                                            })
                                                        ]
                                                    }),
                                                    '⟷',
                                                    create({
                                                        tagName: 'span',
                                                        children: [
                                                            'To  ',
                                                            create({
                                                                tagName: 'span',
                                                                children: `${(props === null || props === void 0 ? void 0 : props.maxVal) ? props.maxVal : '4180'} $`,
                                                                dataAttr: [['id', 'max__range']]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            rangeInputPrice
                                        ]
                                    })
                                ]
                            }),
                            create({
                                tagName: 'div',
                                classNames: 'filters__item',
                                children: [
                                    create({
                                        tagName: 'h3',
                                        classNames: 'filters__item-title',
                                        children: 'Stock'
                                    }),
                                    titleSubline,
                                    create({
                                        tagName: 'div',
                                        classNames: 'range',
                                        children: [
                                            create({
                                                tagName: 'div',
                                                classNames: 'range__text',
                                                children: [
                                                    create({
                                                        tagName: 'span',
                                                        classNames: 'range__span',
                                                        children: [
                                                            'From ',
                                                            create({
                                                                tagName: 'span',
                                                                children: `${(props === null || props === void 0 ? void 0 : props.maxStocks) ? props.minStocks : '2'}`,
                                                                dataAttr: [['id', 'min__range2']]
                                                            })
                                                        ]
                                                    }),
                                                    '⟷',
                                                    create({
                                                        tagName: 'span',
                                                        children: [
                                                            'To  ',
                                                            create({
                                                                tagName: 'span',
                                                                children: `${(props === null || props === void 0 ? void 0 : props.maxStocks) ? props.maxStocks : '500'}`,
                                                                dataAttr: [['id', 'max__range2']]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            rangeInputStock
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ],
                parent: this.parent
            });
        };
        this.parent = parent;
        this.component = null;
        this.onFilterClick = onFilterClick;
        this.onNameClick = onNameClick;
        this.onReSetClick = onReSetClick;
        this.header = header;
    }
}
